import { BookingSummaryApiHandler } from "./BookingSummaryApiHandler";

export function BookingSummaryRouteHandler({ match }) {
  return <BookingSummaryApiHandler bookingId={match?.params.bookingId} />;
}
